<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
          label="姓名"
          prop="drawname"
        >
          <el-input
            v-model="searchForm.drawname"
            placeholder="手机号码"
            style="width: 100px;"
          />
        </el-form-item>

        <el-form-item
          label="手机号码"
          prop="mobileno"
        >
          <el-input
            v-model="searchForm.mobileno"
            placeholder="手机号码"
            style="width: 120px;"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="商户编号"
        prop="agentid"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{scope.row.agentid}}
        </template>
      </el-table-column>

      <el-table-column
        label="开户姓名"
        prop="drawname"
        sortable="custom"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.drawname}}
        </template>
      </el-table-column>
      <el-table-column
        label="身份证号码"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.cert_no}}
        </template>
      </el-table-column>
      <el-table-column
        label="银行卡号"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.bankaccount}}
        </template>
      </el-table-column>
      <el-table-column
              label="预留手机号码"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.mobileno}}
        </template>
      </el-table-column>
      <el-table-column
            label="银行卡类别"
            prop="mobileno"
            sortable="custom"
            :show-overflow-tooltip="true"
    >
      <template slot-scope="scope">
        <div v-if="scope.row.card_type==1">
          贷记卡
        </div>
        <div v-else-if="scope.row.card_type==2">
          借记卡
        </div>
      </template>
    </el-table-column>
      <el-table-column
              label="认证状态"
              prop="approvestate"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">

          <div v-if="scope.row.approvestate==0">
            未认证
          </div>
          <div v-else-if="scope.row.approvestate==1">
            已认证
          </div>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
  </d2-container>
</template>
<script>
import * as cardService from '@/api/sys/card'
export default {
  name: 'CardPage',
  components: {},
  data () {
    return {
      searchForm: {
        drawname: '',
        mobileno: ''
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: '',
        order: ''
      },
      user: {}
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    getTableData () {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        descending: this.sort.order === 'descending',
        filter: this.searchForm
      }
      cardService.getCardPagedList(query).then(data => {
        this.tableData = data.rows
        this.page.total = data.totalCount
      })
    },
    handleSearchFormSubmit () {
      this.getTableData()
    },
    handleSearchFormReset () {
      this.$refs.searchForm.resetFields()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSortChange (val) {
      this.sort.prop = val.prop
      this.sort.order = val.order
      this.getTableData()
    },
    handleSizeChange (val) {
      this.page.size = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.current = val
      this.getTableData()
    }
  }
}
</script>
